  <div class="border-card border-0 px-4 py-1 scroll-container" ref="manage_workflow">
  <NavigationBackButton />
      <div class="card-header card-header-primary shadow-2 rounded-lg mt-3">
        <div class="nav-tabs-navigation">
          <div class="nav-tabs-wrapper">
            <p class="p-1 fw-bold text-white mb-0">Request Details</p>
          </div>
        </div>
      </div>

      <div class="card-body bg-white mt-2 rounded-lg shadow-sm">
        <!-- Request and Resolution Details -->
        <div class="row mt-2 p-3 justify-content-between gap-4">
          <div class="col-md shadow rounded-lg p-4 border border-2">
            <p class="fw-bold text-x">Request information</p>
            <hr class="primary-green">
            <div class="text-xxs">
              <p><strong>Requester :</strong> {{ request_infomation.requested_by_first_name }} {{ request_infomation.requested_by_last_name }}</p>
              <p><strong>Date Requested :</strong> {{ request_infomation.date_created }}</p>
            </div>
          </div>

          <!-- Resolution Details -->
          <div class="col-md shadow rounded-lg p-4 border border-2">
            <p class="fw-bold text-x">Resolution details</p>
            <hr class="primary-green">
            <div class="text-xxs">
              <p><strong>Resolved by :</strong> {{ request_infomation.resolved_by_first_name }} {{ request_infomation.resolved_by_last_name }}</p>
              <p><strong>Date resolved :</strong> {{ request_infomation.date_resolved }}</p>
            </div>
          </div>
        </div>

        <!-- Request History -->
        <div class="card mb-3 border-0 p-1">
          <div class="card-body px-3 py-2 shadow rounded-lg border border-2">
            <p class="mb-3 text-x fw-bold">Requested Fields</p>
            <div class="timeline">
              <div :class="['timeline-container', fields.length > 3 ? 'timeline-scrollable' : '']">
                <div v-for="(item, index) in fields" :key="index" class="timeline-item">
                  <div class="timeline-marker">
                    <div class="timeline-line"></div>
                    <div class="timeline-icon"></div>
                  </div>
                  <div class="timeline-content">
                    <div class="text-xxs">{{ item.label }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-3 border-0 p-1">
          <div class="text-xxs p-3 shadow rounded-lg border border-2">
            <!-- Submitted Documents -->
            <p class="text-x fw-bold">Submitted documents</p>
            <!-- Document Header -->
            <div class="d-flex border rounded-top p-2 custom-header text-white">
            <div class="col-3">Document Name</div>
            <div class="col-3">Date Uploaded</div>
            <div class="col-3">Action</div>
            </div>

            <!-- Document Rows -->
            <div
                v-for="(doc, index) in submitted_documents"
                :key="index"
                class="document-row d-flex border-start border-end border-bottom p-2 align-items-center"
                :class="{
                    'rounded-bottom': index === submitted_documents.length - 1
                }"
            >
                <div class="col-3">{{ doc.name }}</div>
                <div class="col-3">{{ doc.date_created }}</div>

                <div class="col-3 d-flex gap-2">

                  <button type="button" class="btn btn-primary-dark btn-sm text-xxs shadow" @click="open_document(doc)">
                View
              </button>
                </div>
            </div>
          </div>
        </div>
      </div>
  </div>

<div v-if="preview_modal"  @click.self="preview_modal = false">
  <FilePreviewComponent :presigned_url="selected_file.presigned_url" @close="close_the_file_preview"
    :key="selected_file.presigned_url" />
</div>